import React from 'react'
import { Link } from 'react-router-dom'
import EmptyListUI from '../../../widgets/output/EmptyListUI'
import SuperUserLoanPageUI from '../../../templates/SuperUserLoanPageUI.js'
import GenericErrorUI from '../../../components/common/GenericErrorUI'
import SpinnerComponentUI from '../../../components/common/SpinnerComponentUI'
import UseOfProceedsNavUI from '../../../components/superUser/loan/UseOfProceedsNavUI'
import UseOfProceedsDraftSF from '../../../components/superUser/loan/UseOfProceedsDraftSF'
import CreateUseOfProceedsModalSF from '../../../components/superUser/loan/CreateUseOfProceedsModalSF'
import BulkDraftProceedModalSF from '../../../components/superUser/loan/BulkDraftProceedModalSF'
import LRTableActionsUI from '../../../widgets/layout/LRTableActionsUI'
import IconButtonUI from '../../../widgets/action/IconButtonUI'

const UseOfProceedsDraftPageUI = ({ context, errorList, loan, onRefreshClick,
  createMode, onCreateClick, onCreateCancel,
  downloadDraftProceedsTemplateRequested, onDownloadDraftProceedsTemplate,
  bulkUploadMode, onBulkUploadClick, onBulkUploadCancel
}) =>
  <SuperUserLoanPageUI context={context} className='pg_su_loan_a_lst'
    backLink={`/su/${loan && loan.status === 'closed' ? 'closedLoans' : 'loans'}`}
    headerText={loan ? (loan.account.accountName + ' ' + (loan.loanName || '')) : 'Loan'}
    centered={!loan || !errorList} loan={loan} page='proceeds' dimension='w768'
  >
    {
      (!loan || !errorList) &&
      <SpinnerComponentUI />
    }
    {
      errorList && errorList.length > 0 &&
      <GenericErrorUI error={errorList[0]} />
    }
    {
      loan &&
      <LRTableActionsUI location='top'
        left={
          <span className='g_flex_left g_flex_h'>
            <IconButtonUI icon='icon-refresh' onClick={onRefreshClick} />
            {/* {
              loan.status === 'requested' &&
              <IconButtonUI icon='icon-plus' onClick={onCreateClick} />
            } */}
            <span className='g_m_left_100 g_large'><b>Use of Proceeds (Draft)</b></span>
          </span>
        }
        right={
          <div style={{display: 'flex', flexDirection: 'column', alignItems: 'flex-end'}} className='g_m_top_50'>
            <Link to='#' className='g_m_bottom_50' onClick={onBulkUploadClick}>
              Upload Draft Proceed xlsx File
            </Link>
            <Link onClick={onDownloadDraftProceedsTemplate} to='#'>
              Download Draft Use Of Proceeds Template
            </Link>
          </div>
        }
      />
    }
    {
      loan &&
      <UseOfProceedsNavUI loan={loan} page='proceedsdraft' />
    }
    {
      loan &&
      <UseOfProceedsDraftSF
        context={context}
        loan={loan}
        onRefreshClick={onRefreshClick}
      />
    }
    {
      loan && loan.draftProceedsList.length === 0 &&
      <EmptyListUI
        context={context}
        createDisabledMessageLabel='No draft use of proceeds'
      />
    }

    <CreateUseOfProceedsModalSF
      context={context} loan={loan}
      createMode={createMode} onCancelClick={onCreateCancel}
      onRefreshClick={onRefreshClick}
    />

    <BulkDraftProceedModalSF
      context={context}
      loanId={loan && loan.loanId}
      uploadMode={bulkUploadMode}
      onCancelClick={onBulkUploadCancel}
      onRefreshClick={onRefreshClick}
    />

  </SuperUserLoanPageUI>

export default UseOfProceedsDraftPageUI
